/*
创建者 魏强(2018.1.25)
首页 自营
*/
<template>
	<div class="home-module">
        <h3 class="module-title">
        	<span>自营品牌</span>
        </h3>
        <div class="module-selling">
           <div>
                <router-link :to="adUp.to" target="_blank">
                	<img :alt="adUp.aname" :src="adUp.atturl" height="372px" width="1190px">  
                </router-link>
            </div>
            <div class="list">
            	<div class="ad" style="height:348px;">
                    <router-link v-if="adLeft" :to="adLeft.to" target="_blank">
	                	<img :alt="adLeft.aname" :src="adLeft.atturl" width="294px"  height="348px">  
	                </router-link>
                </div>
                <ul>
                	 <li v-for="(item,index) in adRightList" v-if="index<10" :key="item.key" class="double">
	                	 <router-link :to="item.to" :title="item.aname" target="_blank">
	                	 	<img :alt="item.aname" :src="item.atturl" height="170px" width="170px">  
	                	 </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import {parseAdvList} from 'utils/tool.js';
export default {
	props:['data'],
	data(){
        let adUp = parseAdvList(this.data.szsgAdv.advList);//首页-自营品牌上横幅
        let adLeft = parseAdvList(this.data.szzgAdv.advList);//首页-自营品牌左下广告
        let adRightList = parseAdvList(this.data.szygAdv.advList);//首页-自营品牌右下广告
		return {
			adUp:adUp[0],
			adLeft:adLeft[0],
			adRightList
		}
	}
}
</script>



// WEBPACK FOOTER //
// index.vue?3aa5daf7